import {GetStaticProps} from 'next'

import SEO from 'components/elements/SEO'
import LayoutHome from 'components/layouts/LayoutHome'
import sanityClient from 'src/backend/lib/sanityClient'
import TemplateCreateDocumentForm1099 from 'src/components/templates/TemplateCreateDocumentForm1099'
import {TPageComponent} from 'src/types'
import {Make1099Page} from 'src/types/__sanitySchema__'
import {getKeywords} from 'src/utils'

export interface IMake1099Content extends Make1099Page {}
interface IMake1099PageProps {
	content: IMake1099Content
}

const Make1099Page: TPageComponent<IMake1099PageProps> = ({content}) => {
	return (
		<>
			<SEO
				title={content?.seo?.seo_title || content?.title}
				description={content?.seo?.meta_description}
				keywords={getKeywords(content?.seo?.focus_keyword, content?.seo?.focus_synonyms)}
			/>
			<TemplateCreateDocumentForm1099 content={content} />
		</>
	)
}

Make1099Page.displayName = 'Document1099'
Make1099Page.Layout = LayoutHome

export const getStaticProps: GetStaticProps<IMake1099PageProps> = async () => {
	try {
		const w2Content = (await sanityClient.fetch<Make1099Page[]>(`*[_type == "make1099Page"]`))[0]
		return {
			props: {
				content: w2Content,
			},
		}
	} catch {
		return {
			notFound: true,
		}
	}
}

export default Make1099Page
